// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Image_wrapper__2Vrcj","img":"Image_img__254XK","skeleton":"Image_skeleton__2DtMw"};